import styled from "styled-components";

const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
`;

export default ButtonSection;
